export default "__VITE_ASSET__BGDpTFiN__"